import type { Appliance } from '../types/electricity'

export const appliances: Appliance[] = [
  { id: 'ac', name: 'מזגן', emoji: '❄️', watts: 3000, deferrable: false, dailyHours: 8 },
  { id: 'dryer', name: 'מייבש כביסה', emoji: '👕', watts: 3000, deferrable: true, dailyHours: 1 },
  { id: 'washer', name: 'מכונת כביסה', emoji: '🧺', watts: 500, deferrable: true, dailyHours: 1 },
  { id: 'dishwasher', name: 'מדיח כלים', emoji: '🍽️', watts: 1800, deferrable: true, dailyHours: 1.5 },
  { id: 'oven', name: 'תנור', emoji: '🔥', watts: 2700, deferrable: true, dailyHours: 1 },
  { id: 'fridge', name: 'מקרר', emoji: '🧊', watts: 110, deferrable: false, dailyHours: 24 },
  { id: 'tv', name: 'טלוויזיה', emoji: '📺', watts: 100, deferrable: false, dailyHours: 4 },
  { id: 'computer', name: 'מחשב', emoji: '💻', watts: 300, deferrable: false, dailyHours: 6 },
  { id: 'ev', name: 'טעינת רכב חשמלי', emoji: '🚗', watts: 7000, deferrable: true, dailyHours: 6 },
]
